import { PromotionEnumType } from '../enums/promotionEnum';
import axios from '../lib/axios';
import {
  CHECK_CREATE_PROMOTION,
  CREATE_PROMOTION,
  DELETE_PROMOTION,
  FIND_MANY_PROMOTION,
  UPLOAD_IMAGE_PROMOTION,
} from '../lib/endpoints/promotion';
import { PromotionModel } from '../models/promotion';
import { generateImageFileNameWithRandomName } from '../utils/generateImageFileName';

interface PromotionForm {
  promotionName: string;
  promotionType: PromotionEnumType;
  buyProduct: [{ quantity: number; uomQuantity: number; itemCode: string }];
  getProduct: { quantity: number; uomQuantity: number; itemCode: string };
  startDate: string;
  endDate: string;
  merchantId: string[];
  tagId: string;
  limitUse: number;
  limitUseOfCustomer: number;
  limitUserPerDay: number;
  flashSale: boolean;
  flashSaleStartDate: string;
  flashSaleEndDate: string;
  description: string;
}

interface InputFilterPromotion {
  promotionType?: string;
  promotionName?: string;
  tagId?: string;
  merchantId?: string;
  flashSale?: boolean;
  take?: number;
  skip?: number;
}

export const getAllPromotion = async ({
  promotionName,
  promotionType,
  tagId,
  merchantId,
  flashSale,
  take,
  skip,
}: InputFilterPromotion): Promise<PromotionModel[]> => {
  const res = await axios.post(FIND_MANY_PROMOTION, {
    filtter: {
      promotionName: promotionName,
      promotionType: promotionType,
      tagId: tagId,
      merchantId: merchantId,
      flashSale: flashSale,
    },
  });
  return res?.data;
};

export const deletePromotion = async (Id: string): Promise<void> => {
  await axios.delete(DELETE_PROMOTION + Id);
};

export const createPromotionService = async (formData: any): Promise<PromotionForm> => {
  try {
    const resCheck = await axios.post(CHECK_CREATE_PROMOTION, formData);
    console.log(resCheck?.data);

    const failedItems = resCheck.data.filter((item: { status: boolean }) => !item.status);
    const validItems = resCheck.data.filter((item: { status: boolean }) => item.status);

    if (failedItems.length > 0) {
      // Create an error message from the failed items
      const errorMessage = failedItems.map((item: any) => item.message).join('\n');

      // Return an error object including failed & valid items with their merchant IDs
      // eslint-disable-next-line no-throw-literal
      throw {
        message: 'Some products cannot be promoted.',
        errors: errorMessage,
        failedItems: failedItems.map((item: any) => ({
          itemCode: item.itemcode,
          merchantId: item.merchantId,
        })),
        validItems: validItems.map((item: any) => item.merchantId),
      };
    }

    // Proceed with creating promotions only if there are valid items
    if (validItems.length > 0 && resCheck.status === 201) {
      const response = await axios.post(CREATE_PROMOTION, formData);
      return response.data;
    }

    throw new Error('Unexpected response from check endpoint');
  } catch (error) {
    throw error;
  }
};


export const updateImagePromotion = async (id: string, file: File): Promise<void> => {
  try {
    const formData = new FormData();
    formData.append('image', generateImageFileNameWithRandomName(file));

    const uploadUrl = `${UPLOAD_IMAGE_PROMOTION}${id}`;

    const response = await axios.patch(uploadUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    // console.log(response);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateMultiplePromotionImage = async (
  ids: { id: string }[],
  file: File
): Promise<void> => {
  try {
    const promises: Promise<void>[] = [];
    ids.forEach((id) => {
      promises.push(updateImagePromotion(id?.id, file));
    });

    await Promise.all(promises);
    // console.log('All promotions updated successfully.');
  } catch (error) {
    throw error;
  }
};
